import { createContext, useContext } from '@wordpress/element';
const ToggleGroupControlContext = createContext({});
ToggleGroupControlContext.displayName = 'ToggleGroupControlContext';
export const useToggleGroupControlContext = () => useContext(ToggleGroupControlContext);
export default ToggleGroupControlContext;